module.exports = __webpack_public_path__ + "static/img/box-4.fc9c867.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/box-4.png
// module id = zdV6
// module chunks = 1